import { render, staticRenderFns } from "./basic_init.vue?vue&type=template&id=17c7f5cf&"
import script from "./basic_init.vue?vue&type=script&lang=js&"
export * from "./basic_init.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports